import NewPasswordForm from "./newPasswordForm.container";

export default NewPasswordForm;
